import { React, useEffect } from "react";
import { userLogout } from "./API/api";
import { BASE_URL } from "./API/url";
import { environmentBasedAuthentication, isCookieExist,getDataFROMLS } from "./utils";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "./Action/index.js";
import "./App.css";
import Router from "./Router/router";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ReactConfetti from "react-confetti";
import Themes from "./Themes";
import { ConfigProvider } from "antd";
import { useNavigate } from "react-router-dom";
import useAuthentication from "./Hook/useAuthentication.js";

function App() {
  let confettiState = useSelector((state) => state.domain);
  const state = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { storeUserData } = bindActionCreators(Actions, dispatch);
  // useEffect(() => {
    useAuthentication(storeUserData);
  // }, []);

  return (
    <>
      <ConfigProvider theme={{
        token: {
          fontFamily: "Inter"
        }
      }}>
      {confettiState.isConfetti && (
        <ReactConfetti numberOfPieces={1000} recycle={false} />
      )}
      <Router className="App" />
      <ToastContainer autoClose={3000} style={{ width: "fit-content", marginTop:'35px',width:'300px',maxWidth:'300px'}} />
      <Themes />
      </ConfigProvider>
    </>
  );
}

export default App;
